import { render, staticRenderFns } from "./ProductsStarter.vue?vue&type=template&id=1e124618&"
import script from "./ProductsStarter.vue?vue&type=script&lang=js&"
export * from "./ProductsStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports